import * as request from '@/utils/request'
import { getLevel } from '@/utils/chat/chatUtil';

let api = '';


export const getAnswer = (params) => request.post(api + '/Chat', params);




// 开始新会话
export const startNewSession = () => request.post(api + '/NewSession',{ level: getLevel() });

export const download = (params) => request.downloadPost(api+`/downloadChat`, params)

export const delSession = (params) => request.post(api + '/DelSession', params)

